module.exports = __webpack_public_path__ + "static/media/paint10.3c0ed3c6.jpg";